<script setup lang="ts">
import Roles from "~/utils/roles"
import {useChatChannelsStore} from "~/stores/chatChannels"
import {useChatReadStatusStore} from "~/stores/chatReadStatus"
import {storeToRefs} from "pinia"

const isOpened = ref(false)

const {user} = useAuth()
const {channelsList} = storeToRefs(useChatChannelsStore())
const {totalUnread, channelUnreadMessages} = storeToRefs(useChatReadStatusStore())
const emptyChannels = computed(() => channelsList.value.length === 0)
const isSingleChannel = computed(() => channelsList.value.length === 1)

onMounted(async () => {
  await useChatReadStatusStore().load()
})

</script>

<template>
  <v-fab v-if="user?.role !== Roles.ADMIN.value && !emptyChannels"
         app
         color="primary"
         location="bottom right"
         icon
         :to="isSingleChannel ? `/chat/${channelsList[0].id}` : undefined"
  >
    <v-badge
        v-if="totalUnread > 0"
        color="red"
        :content="totalUnread"
        max="99"
    >
      <v-icon>mdi-forum-outline</v-icon>
    </v-badge>
    <v-icon v-else>mdi-forum-outline</v-icon>

    <v-speed-dial
        v-if="!isSingleChannel"
        v-model="isOpened"
        location="top center"
        transition="fade-transition"
        activator="parent"
    >
      <v-btn v-for="channel in channelsList"
             :key="channel.id"
             elevation="12"
             color="primary"
             :to="`/chat/${channel.id}`"
      >
        {{ channel.name }}

        <template v-slot:append>
          <v-badge
              color="red"
              v-if="channelUnreadMessages.get(channel.id)"
              :content="channelUnreadMessages.get(channel.id)"
              max="99"
              inline
              floating
          >
          </v-badge>
        </template>
      </v-btn>
    </v-speed-dial>

  </v-fab>
</template>